import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroller";
import ArrowUp from "@mui/icons-material/ArrowUpward";
import ArrowDown from "@mui/icons-material/ArrowDownward";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { handlingCatchError } from "../../../../Utils/ErrorHandling";
import Tooltip from "@mui/material/Tooltip";
import Chip from "@mui/material/Chip";
import Hiking from "../../../../Assets/Images/icons/Hiking2.png";
import BoatingRentals from "../../../../Assets/Images/icons/Boating Rentals2.png";
import Kayaking from "../../../../Assets/Images/icons/Kayaking2.png";
import Canoeing from "../../../../Assets/Images/icons/Canoeing2.png";
import Others from "../../../../Assets/Images/icons/others2.png";
import { apiCommonTrigger } from "../../../../Utils/apiServicehelper";
import { Config } from "../../../../Utils/Config";

const Activity = (props) => {
  const navigate = useNavigate();

  const [orderBy, setOrderBy] = useState("profileName");
  const [isLoading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [orderDirection, setOrderDirection] = useState(true);
  const [key, setKeys] = useState([]);
  const [activityList, setActivityList] = useState([]);

  const marketId = props && props.marketId ? props.marketId : null;

  useEffect(() => {
    getActivityData();
  }, []);

  const getActivityData = async () => {
    setLoading(true);
     let inputData={ page: page,
        resultsPerPage: rowsPerPage,
        orderBy: orderBy,
        orderDirection: orderDirection ? "Asc" : "Desc",
        marketId: marketId}
   
    await apiCommonTrigger("post",`${Config.API_URL}/markets/market/analysis/activities`,inputData)
    .then((res) => {
      setLoading(false);
      if (res.status === 200) {
        setKeys(res.data.keys);
        setActivityList(res.data.activityanalysis);
      }else{
        handlingCatchError(res, navigate);
      }
    })
    .catch(err => {
      handlingCatchError(err, navigate);
    })
  };

  const handleInfiniteOnLoad = () => {
    setPage(page + 1);
  };

  // sorting in Ascening order
  const sortAsc = () => {
    setActivityList(
      activityList && activityList.length !== 0
        ? activityList.sort(function (a, b) {
            const nameA = a.profilename.toUpperCase();
            const nameB = b.profilename.toUpperCase();

            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          })
        : null
    );
  };

  // sorting in desceing order
  const sortDesc = () => {
    setActivityList(
      activityList.length !== 0
        ? activityList.sort(function (a, b) {
            const nameA = a.profilename.toUpperCase();
            const nameB = b.profilename.toUpperCase();

            if (nameA > nameB) {
              return -1;
            }
            if (nameA < nameB) {
              return 1;
            }
            return 0;
          })
        : null
    );
  };

  const getActivityLabel = (value) => {
    if (!value || !value.activitylist) return []; // Handle invalid input gracefully.  
    const { activitylist } = value;
    const othersActivityList = activitylist && activitylist.Others ? activitylist.Others.split(",") : [];
    const activityKeys = Object.keys(activitylist).filter(key => key !== "Others");  
    const dataset = [...activityKeys, ...othersActivityList];
  
    return dataset.map((amenityHeader, index) => (
      <Chip
        key={index}
        label={amenityHeader}
        style={{
          background: "transparent",
          border: "1px solid #fff",
          color: "#fff",
          lineHeight: "25px",
          fontWeight: "normal",
          fontSize: "12px",
          height: "auto",
          marginRight: "5px",
          marginTop: "2.5px",
          marginBottom: "2.5px"
        }}
      />
    ));
  };

  return (
    <div>
      {isLoading ? (
        <div className="loader-wrap">
          <div className="loading loading-center"></div>
        </div>
      ) : (
        ""
      )}
      <div className="display-grid">
        <div className="amenities-legend"></div>
        <div className="amenities-tab-table amenities-tab-table-two activities-table">
          <div className="table-height">
            <InfiniteScroll
              initialLoad={false}
              loadMore={handleInfiniteOnLoad}
              // hasMore={page !== totalPage}
              threshold={20}
              useWindow={false}
            >
              <Table className="table-design">
                <TableHead>
                  <TableRow>
                    <TableCell className="freeze">
                      <span
                        className={
                          orderBy === "profileName" ? "fontbold" : "fontnormal"
                        }
                        onClick={() => {
                          setOrderBy("profileName");
                          setOrderDirection(!orderDirection);
                          setPage(1);
                          orderDirection  ? sortDesc() : sortAsc()
                        }}
                      >
                        Profile Name
                      </span>
                      <span
                        onClick={() => {
                          setOrderDirection(!orderDirection);
                          setPage(1);
                         orderDirection ? sortDesc() : sortAsc()
                        }}
                      >
                        (Total Activities)
                      </span>
                      {orderDirection ? (
                        <ArrowDown
                          onClick={() => {
                            setOrderBy(orderBy);
                            setOrderDirection(!orderDirection);
                            sortDesc();
                            setPage(1);
                          }}
                        />
                      ) : (
                        <ArrowUp
                          onClick={() => {
                            setOrderBy(orderBy);
                            setOrderDirection(!orderDirection);
                            setPage(1);
                            sortAsc();
                          }}
                        />
                      )}
                    </TableCell>
                    {key.length !== 0
                      ? key.map((keys, index) => {
                          return (
                            <>
                                <TableCell Others>     
                                      <img
                                      src={keys === 'Hiking' ? Hiking:
                                      keys === "Boating/Boat Rentals" ? BoatingRentals :
                                      keys === "Kayaking" ? Kayaking:
                                      keys === "Canoeing" ? Canoeing:
                                      keys ===  "Others" ? Others:
                                    null}
                                      alt="icons"
                                      className="table-icons"
                                  />
                                 {keys}
                                </TableCell>
                           </>
                          )}
                      ):null}  
                                  
                  </TableRow>
                </TableHead>
                <TableBody>
                  {activityList && activityList.length !== 0 ? (
                    activityList.map((act, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell className="freeze">
                            {act.profilename} 
                            <Tooltip style={{cursor: "pointer"}} placement="right" title={getActivityLabel(act)}>
                              <span className="fontbold"> ({act.activitycount}) </span>
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            {act.activitylist.Hiking
                              ? act.activitylist.Hiking
                              : "No"}
                          </TableCell>
                          <TableCell>
                            {act.activitylist["Boating/Boat Rentals"]
                              ? act.activitylist["Boating/Boat Rentals"]
                              : "No"}
                          </TableCell>
                          <TableCell>
                            {act.activitylist.Kayaking
                              ? act.activitylist.Kayaking
                              : "No"}
                          </TableCell>
                          <TableCell>
                            {act.activitylist.Canoeing
                              ? act.activitylist.Canoeing
                              : "No"}
                          </TableCell>
                          <TableCell>
                            {act.activitylist.Others
                              ? act.activitylist.Others
                              : "-"}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={6}
                        style={{ textAlign: "center" }}
                        className="store-no-data"
                      >
                        No records found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </InfiniteScroll>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Activity;
